import {useState} from 'react'

const useFocussedPlaceholder = (initialFocussedValue, initialPlaceholderValue, isRequired) => {
    const getPlaceholder = () =>
        isRequired ? `${initialPlaceholderValue} *` : initialPlaceholderValue

    const [isFocussed, setIsFocussed] = useState(initialFocussedValue)
    const [placeholder, setPlaceholder] = useState(getPlaceholder())

    const handleOnFocus = () => {
        setIsFocussed(true)
        setPlaceholder('')
    }

    const handleOnBlur = () => {
        setIsFocussed(false)
        setPlaceholder(getPlaceholder())
    }

    return {isFocussed, placeholder, handleOnFocus, handleOnBlur}
}

export default useFocussedPlaceholder
